import React from 'react'
import { useHelperModalProps } from './types'
import { wrap } from '../../../utils/globalUtils'
import HelperModalView from './views/HelperModalView'
import useHelperModal from './hooks/useHelperModal'

const HelperModal: React.FC<useHelperModalProps> = wrap(HelperModalView, useHelperModal)
export default HelperModal
